import XEUtils from 'xe-utils'
import VXETable from 'vxe-table-quantdata'
import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import httpManager from '../../util/common'

let vm = {
  delimiters: ['{', '}'],
  data: () => {
    return {
      key: null,
      tableColumn: [
        // {type: 'checkbox', width: 60 },
        {type: 'seq', width: 50},
        {title: 'i18n.user_center.entity_name', field: "entity_name"},
        {title: 'i18n.user_center.ticker', field: "ticker"},
        {title: 'i18n.common.setting_column', width: 200, slots: { default: 'operate' } }
      ],
      entityCount: 0,
      loading: false,
      followOaid: null,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'center',
        layouts: ['PrevPage', 'Number', 'NextPage'],
        perfect: true,
        pagerCount: 3
      },
      data: [], //表单的数据
    }
  },
  methods: {
    removeAll () {
      this.$XModal.confirm('确定取消对选定公司的关注吗?').then(type => {
        if (type === 'confirm') {
          // this.$refs.xGrid.remove(row)
          let self = this
          let params = new Map()
          let oaid = []
           for( let i in self.data){
            if(self.data[i].checked){
              oaid.push(self.data[i].oaid)
            }
          }
          params.set("oaid", oaid.join())
          httpManager("unfollow_entity", params, null, null, null)
            .then(response => {
              self.getFollowEntity()
            })
            .catch(error => {
            })
            }
          })
    },
    followEntity(){
      let urlStr = "follow_entity"
      let self = this
      if (!self.followOaid) {
        return this.$message.warning(this.$t('tips.follow_entity_warning'));
      }
      let params = new Map()
      params.set('oaid', self.followOaid)
      httpManager(urlStr, params)
        .then(response => {
          if (response.data.msg === '超过允许关注最大数量') {
            return this.$message.warning(this.$t('tips.follow_entity_overmax'))
          }
          self.getFollowEntity()
          self.followOaid = null
          this.$message.info(this.$t('tips.follow_entity_tip'));
        })
        .catch(error => {
          console.log(error)
        })
    },
    adjust_up(row){
      this.adjust_order(row.oaid, false)
    },
    adjust_down(row){
      this.adjust_order(row.oaid, true)
    },
    adjust_order(oadi, down){
      let urlStr = "adjust_follow_entity"
      let self = this
      let params = new Map()
      params.set('oaid', oadi)
      params.set('down', down)
      httpManager(urlStr, params)
        .then(response => {
          self.getFollowEntity()
          self.followOaid = null
        })
        .catch(error => {
          console.log(error)
        })
    },
    removeRowEvent (row) {
      this.$XModal.confirm(this.$t('tips.unfollow_entity_confirm')).then(type => {
        if (type === 'confirm') {
          // this.$refs.xGrid.remove(row)
          let self = this
          let params = new Map()
          params.set("oaid", row.oaid)
          httpManager("unfollow_entity", params, null, null, null)
            .then(response => {
              self.getFollowEntity()
              this.$message.info(this.$t('tips.unfollow_entity_tip'));
            })
            .catch(error => {
            })
            }
          })
    },
     pageChange({ currentPage, pageSize }) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getFollowEntity()
    },
    getFollowEntity() {
      let self = this
      self.loading = true
      let params = new Map()
      params.set("pagenum", self.page.currentPage)
      params.set("pagesize", self.page.pageSize)
      if(self.key){
        params.set("key", self.key)
      }
      httpManager("follow_entities", params, null, null, null)
        .then(response => {
          self.data = response.data.data
          // for(let d in self.data){
          //   self.data[d].checked = false
          // }
          let page = response.data.page
          self.page.total = page.total
          self.loading = false
        })
        .catch(error => {
          self.loading = false
        })
    },
  },
  computed: {
  },
  mounted () {
    this.getFollowEntity()
  }


}
Vue.component("follow-company", vm)
export default vm



// WEBPACK FOOTER //
// ./src/user_center/js/follow_company.js